import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { StorageService } from './../../../services/storage/storage.service';
import { PredefinedTemplatesService } from './../../../services/edit/predefined-templates.service';
import { ColorsService } from './../../../services/colors/colors.service';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';

@Component({
  selector: 'edit-component',
  templateUrl: './edit-component.component.html',
  styleUrls: ['./edit-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditComponentComponent extends SidenavContent implements OnChanges {
  @Input() component: any;
  typeOf: any;
  rowType: any;
  rowArray: any;
  compArray: any;
  template: any;
  dynamic = true;
  edit: boolean;
  widgetEdit: boolean;
  empty: any = '';
  starterTheme = '';
  currentTheme: any;
  colors: any;

  constructor(
    private _layoutService: LayoutService,
    private _colorsService: ColorsService,
    private _predefinedTemplatesService: PredefinedTemplatesService,
    private _storageService: StorageService,
  ) {
    super(_layoutService);
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.component) {
        this.component = changes.component.currentValue;
        this.typeOf = this.component.typeOf;
        this.rowType = this.component.rowType;
        this.rowArray = this.component.rowArray;
        this.compArray = this.component.compArray;
        this.template = this.component.template;
        this.edit = this.component.edit;
        this.dynamic = this.component.dynamic ?? true;
        this.widgetEdit = this.component.widgetEdit ?? false;
        this.starterTheme = '';
        // load the more options in showcase, image, poular showcase, list showcase etc components with the default theme selected colors
        if (!this.edit) {
          let header = this._storageService.getItem('layoutSettings');
          if (!header || !header.styles || !header.styles[0] || !header.styles[0].starterTheme) {
            const cid = this._storageService.getCid();
            const lid = this._storageService.getLid();
            header = await this._predefinedTemplatesService.getLayoutSettingsAsync(cid, lid);
          }
          if (header && header.styles && header.styles[0] && header.styles[0].starterTheme) {
            this.starterTheme = header.styles[0].starterTheme;
            this.colors = this.checkTheme(this.starterTheme); // check theme
          }
        }
      }
    }
  }

  private checkTheme(name) {
    let defaultTheme;
    let obj;
    switch (name) {
      case 'olivegreen':
        defaultTheme = this._colorsService.setGreen();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'purple':
        defaultTheme = this._colorsService.setPurple();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'lightblue':
        defaultTheme = this._colorsService.setLightBlue();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'royal':
        defaultTheme = this._colorsService.setRoyal();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'lightgreen':
        defaultTheme = this._colorsService.setLightGreen();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'orange':
        defaultTheme = this._colorsService.setOrange();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'pink':
        defaultTheme = this._colorsService.setPink();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'red':
        defaultTheme = this._colorsService.setRed();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'brown':
        defaultTheme = this._colorsService.setBrown();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'bluegrey':
        defaultTheme = this._colorsService.setBlueGrey();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
      case 'default':
        defaultTheme = this._colorsService.defaultColorTheme();
        obj = {
          fontColor: defaultTheme.headerColor,
          // 'backColor':defaultTheme.shadeTwo
          backColor: '',
        };
        return obj;
    }
  }
}
